import React from 'react'
import styled from 'styled-components'
import { IonHeader, IonSegment } from '@ionic/react'
import { get, noop, map } from 'lodash'
import { CardCategory } from './CardTitleOverImage'
import { colors } from '../helpers'

export const CategoriesHeader = ({
  theme,
  data,
  currentCategory,
  setCurrentCategory,
  onClick = noop,
  onScroll = noop
}) => {
  return (
    <Header translucent>
      <WrapperIonSegment
        onScroll={onScroll}
        color={colors[get(theme, 'color.backgroundHeader')]}
        scrollable
        mode='md'
        onIonChange={(props) => setCurrentCategory(props.detail.value)}
      >
        {map(data, (value) => (
          <CardCategory
            theme={theme}
            key={value.id}
            onClick={onClick}
            currentCategory={currentCategory}
            id={value.id}
            name={value.name}
            picture={value.picture}
          />
        ))}
      </WrapperIonSegment>
    </Header>
  )
}

const WrapperIonSegment = styled(IonSegment)`
  padding-left: 8px;
  background-color: ${(props) => props.color};
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  ::-webkit-scrollbar {
    display: none;
  }
`

const Header = styled(IonHeader)`
  box-shadow: 0px 10px 10px -7px rgba(0, 0, 0, 0.15);
  & ::after {
    height: 0;
    display: none;
  }
`
